(function () {
  'use strict';

  function findBtn() {
    return (
      document.querySelector('[data-testid="standalone-add-to-cart"]') ||
      document.querySelector('.product-details .add-to-cart-button') ||
      document.querySelector('add-to-cart-component .add-to-cart-button') ||
      document.querySelector('form[action*="/cart/add"] .add-to-cart-button')
    );
  }

  function init() {
    var btn = findBtn();
    if (!btn || btn.dataset.liveBtn) return;
    btn.dataset.liveBtn = '1';

    btn.style.borderRadius = '50px';
    btn.style.position     = 'relative';
    btn.style.overflow     = 'visible';

    var parent = btn.closest('add-to-cart-component, span[class]');
    if (parent) {
      parent.style.borderRadius = '50px';
      parent.style.overflow     = 'visible';
    }

    var rect = btn.getBoundingClientRect();
    var W    = rect.width  || btn.offsetWidth  || 220;
    var H    = rect.height || btn.offsetHeight || 52;
    var R    = Math.min(H / 2, 26);
    var PAD  = 3;
    var sW   = W + PAD * 2;
    var sH   = H + PAD * 2;
    var pR   = R + PAD;

    var p = [
      'M', PAD + pR, PAD,
      'h', W - R * 2,
      'a', pR, pR, 0, 0, 1,  pR,  pR,
      'v', H - R * 2,
      'a', pR, pR, 0, 0, 1, -pR,  pR,
      'h', -(W - R * 2),
      'a', pR, pR, 0, 0, 1, -pR, -pR,
      'v', -(H - R * 2),
      'a', pR, pR, 0, 0, 1,  pR, -pR,
      'Z'
    ].join(' ');

    var perim  = 2 * (W - R * 2) + 2 * (H - R * 2) + 2 * Math.PI * pR;
    var dotLen = perim * 0.10; // short segment — 10% of perimeter

    var ns  = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width',  sW);
    svg.setAttribute('height', sH);
    Object.assign(svg.style, {
      position      : 'absolute',
      top           : -PAD + 'px',
      left          : -PAD + 'px',
      pointerEvents : 'none',
      zIndex        : '10',
      overflow      : 'visible',
    });

    svg.innerHTML = [
      '<defs>',
        '<filter id="lf-glow" x="-100%" y="-100%" width="300%" height="300%">',
          '<feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="blur"/>',
          '<feMerge>',
            '<feMergeNode in="blur"/>',
            '<feMergeNode in="SourceGraphic"/>',
          '</feMerge>',
        '</filter>',
      '</defs>',

      /* Faint static border */
      '<path d="' + p + '" fill="none"',
        'stroke="rgba(255,255,255,0.12)" stroke-width="1"/>',

      /* Soft outer glow — slightly wider, low opacity */
      '<path d="' + p + '" fill="none"',
        'stroke="rgba(255,255,255,0.45)" stroke-width="2.5"',
        'stroke-linecap="round"',
        'stroke-dasharray="' + dotLen + ' ' + perim * 2 + '"',
        'filter="url(#lf-glow)">',
        '<animate attributeName="stroke-dashoffset"',
          'from="0" to="-' + perim + '"',
          'dur="2s" repeatCount="indefinite" calcMode="linear"/>',
      '</path>',

      /* Crisp thin bright core line */
      '<path d="' + p + '" fill="none"',
        'stroke="rgba(255,255,255,0.98)" stroke-width="1"',
        'stroke-linecap="round"',
        'stroke-dasharray="' + dotLen * 0.6 + ' ' + perim * 2 + '"',
        'filter="url(#lf-glow)">',
        '<animate attributeName="stroke-dashoffset"',
          'from="0" to="-' + perim + '"',
          'dur="2s" repeatCount="indefinite" calcMode="linear"/>',
      '</path>',

    ].join('');

    btn.appendChild(svg);
  }

  function tryInit() {
    if (findBtn()) { init(); }
    else           { setTimeout(tryInit, 400); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInit, 500); });
  } else {
    setTimeout(tryInit, 500);
  }

})();
